import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  EventsControllerDtoDrawItemCreateRequest,
  EventsControllerDtoDrawItemDetailRequest,
  EventsControllerDtoDrawItemListRequest,
  EventsControllerDtoDrawItemLogListRequest, EventsControllerDtoDrawItemRemoveRequest,
  PerplayEventsApi
} from '../../models/src';
import EventsControllerDtoDrawItemLogListResponse
  from '../../models/src/model/EventsControllerDtoDrawItemLogListResponse';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import {
  DRAW_ITEM_EVENT_CREATE_REQUEST, DRAW_ITEM_EVENT_INFO_REQUEST,
  DRAW_ITEM_EVENT_LIST_REQUEST, DRAW_ITEM_EVENT_LOG_INFO_REQUEST, DRAW_ITEM_EVENT_REMOVE_REQUEST
} from '../../constants/event/drawItemEventConstants';
import { drawItemEventCreateRequest, drawItemEventRemoveRequest } from '../../actions/event/drawItemEventActions';
import EventsControllerDtoDrawItemCreateResponse
  from '../../models/src/model/EventsControllerDtoDrawItemCreateResponse';
import EventsControllerDtoDrawItemListResponse from '../../models/src/model/EventsControllerDtoDrawItemListResponse';
import EventsControllerDtoDrawItemDetailResponse
  from '../../models/src/model/EventsControllerDtoDrawItemDetailResponse';
import BaseResponse from '../../models/src/model/BaseResponse';

const api = new PerplayEventsApi(config.API_CLIENT);

function* drawItemEventListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoDrawItemListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.searchString = payload.searchString;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventDrawItemInfoListPost({ eventsControllerDtoDrawItemListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, EventsControllerDtoDrawItemListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    console.log(e);
    payload.error(e);
  }
}

function* drawItemEventCreateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    console.log(JSON.stringify(payload));
    const result = yield api.apiPerplayEventsEventDrawItemInfoCreatePost(
      payload.title,
      payload.tokenType,
      payload.price,
      payload.purchaseLimit,
      payload.descImage,
      payload.beginAt,
      payload.endAt,
      payload.reward,
      payload,
      () => {}
    );
    console.log(result);
    const data = api.apiClient.deserialize(result, EventsControllerDtoDrawItemCreateResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* drawItemEventInfoDetailRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoDrawItemDetailRequest();
    requestData.drawItemNo = payload.drawItemNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventDrawItemInfoDetailPost({ eventsControllerDtoDrawItemDetailRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, EventsControllerDtoDrawItemDetailResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* drawItemEventLogInfoRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoDrawItemLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.searchType = payload.searchType;
    requestData.searchString = payload.searchString;
    requestData.drawItemNo = payload.drawItemNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventDrawItemLogListPost({ eventsControllerDtoDrawItemLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, EventsControllerDtoDrawItemLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* drawItemEventRemoveRequesttSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoDrawItemRemoveRequest();
    requestData.drawItemNo = payload.drawItemNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventDrawItemInfoRemovePost({ eventsControllerDtoDrawItemRemoveRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* drawItemEventRootSaga() {
  yield all([
    takeEvery(DRAW_ITEM_EVENT_LIST_REQUEST, drawItemEventListRequestSaga),
    takeEvery(DRAW_ITEM_EVENT_CREATE_REQUEST, drawItemEventCreateRequestSaga),
    takeEvery(DRAW_ITEM_EVENT_INFO_REQUEST, drawItemEventInfoDetailRequestSaga),
    takeEvery(DRAW_ITEM_EVENT_LOG_INFO_REQUEST, drawItemEventLogInfoRequestSaga),
    takeEvery(DRAW_ITEM_EVENT_REMOVE_REQUEST, drawItemEventRemoveRequesttSaga),
  ])
}

const drawItemEventSagas = [
  fork(drawItemEventRootSaga),
];

export default drawItemEventSagas;
